var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "right icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.32785 10.9998H19.4998C20.0521 10.9998 20.4998 11.4475 20.4998 11.9998C20.4998 12.5521 20.0521 12.9998 19.4998 12.9998H8.32785L12.9848 17.6568C13.3753 18.0472 13.3753 18.6803 12.9848 19.0708C12.5944 19.4612 11.9613 19.4612 11.5708 19.0708L5.20696 12.7069C4.81643 12.3164 4.81643 11.6832 5.20696 11.2927L11.5708 4.92877C11.9613 4.53831 12.5944 4.53831 12.9848 4.92877C13.3753 5.31924 13.3753 5.95231 12.9848 6.34277L8.32785 10.9998Z",
    fill: "#40444A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBack);
export default __webpack_public_path__ + "static/media/icon_back.c1ebf74e9ee58458f2118eecf2acee57.svg";
export { ForwardRef as ReactComponent };